import {
  AUTH_ROUTE,
  DOWNLOAD_ROUTE,
  EMAIL_CONFIRMATION_ROUTE,
  PUBLIC_DOWNLOAD_ROUTE, RESET_PASSWORD_CONFIRM_ROUTE, RESET_PASSWORD_ROUTE,
  SIGN_IN_ROUTE,
  SIGN_UP_ROUTE,
} from '@/router/routes';
import RootRoute from '@/v1/pages/RootRoute.vue';

const ResetPasswordPage = () =>
  import('@/v1/pages/ResetPasswordPage.vue');
// const NotFound = () => import('@/pages/NotFound/NotFound.vue');
const SignInPage = () => import('@/v1/pages/SignInPage.vue');
const SignUpPage = () => import('@/v1/pages/SignUpPage.vue');
const DownloadPage = () => import('@/v1/pages/DownloadPage.vue');
const PublicDownloadPage = () => import('@/v1/pages/PublicDownloadPage.vue');
const AuthConfirmPage = () => import('@/v1/pages/AuthConfirmPage.vue');
const EmailConfirmationPage = () =>
  import('@/v1/pages/EmailConfirmationPage.vue');

export const v1RouterSegment = [
  {
    path: '/',
    component: RootRoute,
    children: [
      {
        path: '',
        name: SIGN_UP_ROUTE.name,
        component: SignUpPage,
        meta: { amplitudeTitle: '[Web] Sign Up' },
      },
      {
        path: SIGN_IN_ROUTE.path,
        name: SIGN_IN_ROUTE.name,
        component: SignInPage,
        meta: { amplitudeTitle: '[Web] Sign In' },
      },
      {
        path: EMAIL_CONFIRMATION_ROUTE.path,
        name: EMAIL_CONFIRMATION_ROUTE.name,
        component: EmailConfirmationPage,
        meta: { amplitudeTitle: '[Web] Sign In' },

      },
      {
        path: DOWNLOAD_ROUTE.path,
        name: DOWNLOAD_ROUTE.name,
        component: DownloadPage,
        meta: { requiresAuth: true, amplitudeTitle: '[Web] Download' },
      },
      {
        path: PUBLIC_DOWNLOAD_ROUTE.path,
        name: PUBLIC_DOWNLOAD_ROUTE.name,
        component: PublicDownloadPage,
        meta: { amplitudeTitle: '[Web] Download' },
      },
      {
        path: RESET_PASSWORD_ROUTE.path,
        name: RESET_PASSWORD_ROUTE.name,
        component: ResetPasswordPage,
        meta: { amplitudeTitle: '[Web] Reset Password' },
      },
      {
        path: RESET_PASSWORD_CONFIRM_ROUTE.path,
        name: RESET_PASSWORD_CONFIRM_ROUTE.name,
        component: ResetPasswordPage,
        props: true,
        meta: { amplitudeTitle: '[Web] Reset Password Confirm' },
      },
      {
        path: AUTH_ROUTE.path,
        name: AUTH_ROUTE.name,
        component: AuthConfirmPage,
      },
    ],
  },
];